/**
 * Firebase Web SDK config.
 *
 * These values are PUBLIC identifiers (not secrets) — safe to ship in
 * client code, same as any Firebase web app. They just tell the SDK which
 * Firebase project to talk to; access is still governed by Auth +
 * Firestore/Storage security rules.
 *
 * Get these from: Firebase Console → Project settings → General →
 * "Your apps" → Web app → SDK setup and configuration → Config.
 *
 * Fill in after `firebase init` (see README "Deployment"). Do NOT put the
 * OpenAI key here — that lives only in the Cloud Function secret.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyDL0tQnNDXyoOY9DaCW9wqf4m_z0PYgkTE',
  authDomain: 'kavi-f4d01.firebaseapp.com',
  projectId: 'kavi-f4d01',
  storageBucket: 'kavi-f4d01.firebasestorage.app',
  messagingSenderId: '56206248219',
  appId: '1:56206248219:web:21ed60b80144825e2cabbe',
  measurementId: 'G-XR4LK668TV',
};

// Set to true to run against the local Firebase Emulator Suite
// (npm run emulators). See README "Local development".
export const USE_EMULATORS = false;

// Region the Cloud Functions are deployed to (must match functions/index.js).
export const FUNCTIONS_REGION = 'us-central1';

// ── App Check (bot / abuse protection) ───────────────────────────────────
//
// App Check attaches a signed token (from reCAPTCHA v3, invisible to real
// users) to every Firestore/Storage/Functions request, proving it came from
// this real app in a real browser rather than a script hitting the API
// directly with just the public config values above. To turn it on:
//
//   1. Firebase Console → Build → App Check → Apps → this web app →
//      Register → reCAPTCHA v3 → create/select a reCAPTCHA v3 site key for
//      this domain (console.cloud.google.com/security/recaptcha, or the
//      Console does this for you) → paste that site key below.
//   2. Still in App Check, for Firestore/Storage/Functions: set enforcement
//      to "Enforced" (start with "Unenforced" / monitor mode for a day or
//      two first to make sure real traffic isn't getting rejected).
//
// Until RECAPTCHA_V3_SITE_KEY is filled in, src/firebase.js skips
// initializeAppCheck entirely — the app keeps working exactly as before,
// just without this extra layer.
export const RECAPTCHA_V3_SITE_KEY = '6Lf4s2ctAAAAAItCdw3oo04Cr2JGFEVfWK-PDGaG';
